import React, { createContext, useContext, useState, ReactNode } from "react";

interface Alert {
  alert_id: string;
  project_name: string;
  alert_dismissed: string[];
  unit_name: string;
  timestamp: string;
  unit_id: string;
  message: string;
  project_id: string;
  site_id: string;
  site_name: string;
}

interface AlertsContextType {
  alerts: Alert[];
  addAlert: (alert: Alert) => void;
  setAlertContext: (alerts: Alert[]) => void;
}

const AlertsContext = createContext<AlertsContextType | undefined>(undefined);

export const AlertsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [alerts, setAlerts] = useState<Alert[]>([]);

  const addAlert = (alert: Alert) => setAlerts((prev) => [...prev, alert]);

  const setAlertContext = (newAlerts: Alert[]) => setAlerts(newAlerts);

  return <AlertsContext.Provider value={{ alerts, addAlert, setAlertContext }}>{children}</AlertsContext.Provider>;
};

export const useAlerts = (): AlertsContextType => {
  const context = useContext(AlertsContext);
  if (!context) {
    throw new Error("useAlerts must be used within an AlertsProvider");
  }
  return context;
};
